import React from 'react'
import Form from "../../../components/form/Form";
import ReactDOM from "react-dom";
import Component from "../../../components/Component";
import User from "../../../models/User";

export default class PreferenceRatings extends Component {

    constructor(props) {
        super(props);

        this.formRef = React.createRef();
    }

    /**
     * The first invalid field
     */
    invalidFields() {
        if (!this.formRef.current) {
            return false
        }
        let invalid = this.formRef.current.forceValidate();

        if (invalid) {
            const node = ReactDOM.findDOMNode(invalid);

            $('html, body').animate({scrollTop: $(node).offset().top}, 1000);
        }
        return invalid;
    }

    mapping(model) {
        let result = {...this.props.preferences};

        for (let [key, value] of Object.entries(model)) {
            result = TB.set(result, key, value);
        }

        return result;
    }

    formFields() {

        let fields = TB.map(User.GroupedTalentWorkPreferences, (group) => {

        let groups = [];

        TB.map(group, (preferences, groupLabel) => {
                const groupKey = TB.slugify(TB.toLower(groupLabel));

                let groupFields = {}
                groupFields[groupKey + 'header'] = (
                    <label className="col-form-label">
                        {groupLabel}
                    </label>
                )

                TB.map(preferences, preference => {
                    groupFields[`talent_work_preferences[${preference.key}]`] = {
                        type: 'preference-rating',
                        required: false,
                        ...preference
                    }
                })
                groups.push({fields: groupFields})
            });

            return {
                style: {flex: 1},
                className: 'field-section work-preferences-group',
                fields: groups
            }
        })


        return [
            {
                style: {
                    flexDirection: 'row',
                    alignItems: 'flex-start',
                    justifyContent: 'space-evenly'
                },
                groupStyle: {
                    flex: 1,
                    padding: '0 10px'
                },
                fields: {
                    ratingFormHeader: (
                        <div className="rating-form-header">
                            <p className="mb-1">
                                On a scale of 1-5, please rate your interest in the following:
                            </p>
                            <div className="flex flex-row gap-3 items-center">
                                <div className="col col-auto pl-0">
                                    <p className="text-xs font-medium">1 = Not Interested</p>
                                </div>
                                <div className="col col-auto">
                                    <p className="text-xs font-medium">5 = Very Interested</p>
                                </div>
                            </div>
                        </div>
                    )
                }
            },
            {
                style: {
                    flexDirection: 'row',
                    alignItems: 'flex-start',
                    justifyContent: 'space-evenly'
                },
                groupStyle: {
                    flexGrow: 1,
                    padding: '0 10px'
                },
                groupClass: 'work-preferences-section',
                fields
            }
        ]
    }

    render() {
        return (
            <Form
                ref={this.formRef}
                showRequired
                className="work-preference-form pref-ratings-form"
                background={'transparent'}
                title={null}
                subtitle={null}
                submitButton={false}
                mapping={model => this.mapping(model)}
                onSubmit={null}
                model={this.props.preferences}
                onChange={(model) => {
                    if (this.props.disabled) return;

                    return this.props.onChange(this.mapping(model));
                }}
                fields={this.formFields()}
                isDisabled={this.props.disabled}/>
        );
    }
}